import { FC } from 'react';
import { LandscapeImageBlockOrganism } from '../../organisms';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { Label } from '../../atoms';
import cn from 'classnames';
import styles from './LandscapeImageBlockEditTemplate.module.css';
import { ImageBlockResponseDto } from '../../../store/landscapeAPI/block/dto/response/image-block-response.dto';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

export interface LandscapeImageBlockEditTemplateProps {
  handleOnChange: (imageBlock: ImageBlockResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  handleBackgroundOnChange: (imageMeta: ImageMeta) => void;
  imageBlock: ImageBlockResponseDto;
  callbackFn: (imageBlock: ImageBlockResponseDto) => void;
}

const LandscapeImageBlockEditTemplate: FC<
  LandscapeImageBlockEditTemplateProps
> = ({
  handleOnChange,
  handleImageOnChange,
  imageBlock,
  callbackFn,
  handleBackgroundOnChange,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <div className={cn(styles.labelWrapper)}>
          <Label content="Update Image Block" size="lg" />
        </div>
        <LandscapeImageBlockOrganism
          handleOnChange={handleOnChange}
          handleImageOnChange={handleImageOnChange}
          handleBackgroundOnChange={handleBackgroundOnChange}
          imageBlock={imageBlock}
          callbackFn={callbackFn}
        />
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeImageBlockEditTemplate;
